import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Создаем клиент React Query с оптимальными настройками для чата
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Кеш на 5 минут для чатов
      staleTime: 5 * 60 * 1000,
      // Данные считаются свежими 1 минуту
      gcTime: 10 * 60 * 1000,
      // Повторные запросы при ошибках
      retry: 2,
      // Рефетч при фокусе окна
      refetchOnWindowFocus: true,
      // Рефетч при переподключении
      refetchOnReconnect: true
    },
    mutations: {
      retry: 1
    }
  }
});

interface ChatQueryProviderProps {
  children: React.ReactNode;
}

export const ChatQueryProvider: React.FC<ChatQueryProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};

export { queryClient };
